import type { AssetStoryblok } from '@/storyblok/component-types-sb'

export const useResponsiveAsset = (
  mobileAsset?: AssetStoryblok,
  tabletAsset?: AssetStoryblok,
  smallDesktopAsset?: AssetStoryblok,
  largeDesktopAsset?: AssetStoryblok
) => {
  const { getAssetData } = useStoryblokAssetData()
  const { isDesktopLarge, isDesktopSmall, isTablet, isMobile } = useBTBreakpoints()

  if (isDesktopLarge.value) return getAssetData(largeDesktopAsset)
  if (isDesktopSmall.value) return getAssetData(smallDesktopAsset)
  if (isTablet.value) return getAssetData(tabletAsset)
  if (isMobile.value) return getAssetData(mobileAsset)

  return (
    getAssetData(largeDesktopAsset) ||
    getAssetData(smallDesktopAsset) ||
    getAssetData(tabletAsset) ||
    getAssetData(mobileAsset) ||
    null
  )
}
